import welcomeActionKeys from './welcomeActionKeys';
import * as welcomeService from './welcomeService';

const updateBusinessDescription = (serviceProviderId, businessDescription) => ({
  type: welcomeActionKeys.UPDATE_BUSINESS_DESCRIPTION,
  payload: welcomeService.updateBusinessDescription(serviceProviderId, businessDescription),
});

/* eslint-disable import/prefer-default-export */
export { updateBusinessDescription };



// WEBPACK FOOTER //
// ./src/modules/home/common/welcomeActions.js